module.exports = __webpack_public_path__ + "img/de.c4aec2f3.svg";